<template>
  <div>
    <div class="header">
      <h1 class="page-title">余额流水</h1>
    </div>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <ul class="menuItems clearfix">
          <li @click="selectStatus(1)">
            <a>收入明细</a>
          </li>
          <li @click="selectStatus(2)">
            <a>支出明细</a>
          </li>
          <!-- <li>
            <a>消费明细</a>
          </li>-->
          <li @click="selectStatus(3)">
            <a>售后明细</a>
          </li>
        </ul>
        <div class="block">
          <span>下单日期</span>

          <el-date-picker
            v-model="value2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
            :picker-options="pickerOptions"
          ></el-date-picker>
          
          <input type="text" v-model="queryInfo.keyword" placeholder="请输入您要搜索的内容" />
          <button class="searchBtn" @click="selectStatus()">搜索</button>
          <div class="sy-zongj">
            <i>总计：</i>
            <span>
              总收入:
              <b>{{money.srmoney}}元</b>
            </span>
            <span>
              售后收入:
              <b>{{money.shmoney}}元</b>
            </span>
            <span>
              总支出:
              <b>{{money.zcmoney}}元</b>
            </span>
          </div>
        </div>
      </div>

      <div class="main">
        <el-table
          v-loading="loading"
          :data="reportList.data"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            :resizable="false"
            type="index"
            :index="indexMethod"
            width="50"
            label="序 号"
          ></el-table-column>
          <el-table-column width="100" :resizable="false" prop="bussinessno" label="订单号"></el-table-column>
          <el-table-column width="100" :resizable="false" prop="id" label="流水号">
            <template slot-scope="scope">{{PrefixInteger(scope.row.id,8)}}</template>
          </el-table-column>
          <el-table-column :resizable="false" prop="memo" label="备注"></el-table-column>
          <el-table-column width="350" :resizable="false" prop="file" label="文件名"></el-table-column>
          <el-table-column :resizable="false" prop="type" label="收入/支出"></el-table-column>
          <el-table-column :resizable="false" prop="money" label="收支金额"></el-table-column>
          <el-table-column :resizable="false" prop="after" label="账户余额"></el-table-column>
          <el-table-column :resizable="false" prop="createtime" label="日期">
            <template slot-scope="scope">{{scope.row.createtime | dateFormat}}</template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="page_count"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </el-card>

    <a
      :href="baseUrl + `/api/mine/billexplode/uid/${uId}${queryInfo.status==''?'':`/status/${queryInfo.status}`}${queryInfo.mindate==''?'':`/mindate/${queryInfo.mindate}`}${queryInfo.maxdate==''?'':`/maxdate/${queryInfo.maxdate}`}`"
      id="exportTable"
      class="btn btn-default"
    >导出excel</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      value2: '',
      loading: true,
      reportList: [],
      queryInfo: {
        token: window.localStorage.getItem('token'),
        status: '',
        mindate: '',
        maxdate: '',
        page: 1,
        keywords:''
      },
      page_count: 1,
      money: {},
      uId: '',
      baseUrl: ''
    }
  },
  created() {
    const url = window.location.host
    this.baseUrl = !url.includes('192')
      ? 'http://' + url
      : 'https://www.yunshanyin.net'
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.uId = JSON.parse(u).id
    }
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryReportList()
    this.getYue()
  },

  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    indexMethod(index) {
      if (this.queryInfo.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.queryInfo.page + '' + 0
      }
      return this.queryInfo.page - 1 + '' + (index + 1)
    },
    PrefixInteger(num, length) {
      return ('00000000' + num).substr(-length)
    },
    handleCurrentChange(val) {
      this.queryInfo.page = val
      this.queryReportList()
    },
    selectStatus(status = '') {
      this.queryInfo.status = status
      this.queryReportList()
    },
    date() {
      if (this.value2 != null) {
        this.queryInfo.mindate = this.value2[0] + ' 00:00:00'
        this.queryInfo.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.queryInfo.mindate = ''
        this.queryInfo.maxdate = ''
      }
    },
    //   查询报表数据
    async queryReportList() {
      let param = new URLSearchParams()
      for (let key in this.queryInfo) {
        param.append(key, this.queryInfo[key])
      }
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/bill',
        data: param
      })
      this.loading = false
      if (res.code == 1) {
        this.reportList = res.data
        // this.reportList.data = this.reportList.data.reverse()
        // this.reportList.data[2].bussinessno==0?null:this.reportList.data[2].bussinessno
        for (let i in this.reportList.data) {
          this.reportList.data[i].bussinessno == 0
            ? (this.reportList.data[i].bussinessno = null)
            : (this.reportList.data[i].bussinessno = this.reportList.data[
                i
              ].bussinessno)
        }
        this.page_count = res.data.page_count * 10
        let resl = res.data.data
        let countprice = 0
        let zhichuprice = 0
        this.money = res.data.money
      }
    }
  },
  // filters: {
  //   num(num, length = 8) {
  //     return ('00000000' + num).substr(-length)
  //   }
  // },
  mounted() {
    $('.menuItems').on('click', 'li', function() {
      $(this)
        .children('a')
        .css({ color: '#a77c5a', 'border-left': '3px solid #a77c5a' })
      $(this)
        .siblings('li')
        .children('a')
        .css({ color: '#666', 'border-left': '3px solid #ccc' })
    })
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.el-card {
  ul {
    li {
      float: left;
      padding: 0px 15px;
      margin-right: 30px;
      height: 30px;
      cursor: pointer;
      a {
        padding-left: 5px;
        display: block;
        height: 15px;
        line-height: 15px;
        border-left: 3px solid #ccc;
        transition: all 0.3s;
      }
      a:hover {
        border-left: 3px solid #a77c5a;
      }
    }
  }
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      span {
        margin-right: 20px;
        b {
          color: #e83030;
        }
      }
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
</style>